import React, { useState } from 'react';
import Item from "./Item";
import LeftPanelHeader from './LeftPanelHeader';
import LeftPanelControls from './LeftPanelControls';
import TableControls from './TableControls';
import TableHeader from './TableHeader';

const Table = () => {
    const requests = JSON.parse(localStorage.getItem('submittedData')) || [];
    const [filter, setFilter] = useState('all');
    const [filteredRequests, setFilteredRequests] = useState({
        all: requests,
        new: requests.filter((item) => item.status === 'new'),
        inwork: requests.filter((item) => item.status === 'inwork'),
        complete: requests.filter((item) => item.status === 'complete')
    });
    const [selectedProduct, setSelectedProduct] = useState('all');

    const filterRequests = (requests, status, product) => {
        return requests.filter((item) => item.status === status || item.product === product);
    }

    const handleFilterChange = (status) => {
        setFilter(status);
        setFilteredRequests({
        ...filteredRequests,
        [status]: filterRequests(requests, status)
        });
    }

    function filterItems(arr, status, product) {
        if (status === 'all' && product === 'all') {
          return arr;
        } else if (status === 'all' && product !== 'all') {
          return arr.filter(item => item.product === product);
        } else if (status !== 'all' && product === 'all') {
          return arr.filter(item => item.status === status);
        } else if (status !== 'all' && product !== 'all') {
          return arr.filter(item => item.status === status && item.product === product);
        }
      }
      

    return (
        <div>
            <div className="left-panel blue-skin">
                <LeftPanelHeader />
                <LeftPanelControls  filter={filter} filteredRequests={filteredRequests} handleFilterChange={handleFilterChange}  />
            </div>

            <div className="main-wrapper">
                
                <div className="container-fluid">
                    <div className="admin-heading-1">Все заявки</div>

                    <TableControls filter={filter} handleFilterChange={handleFilterChange}
                     selectedProduct={selectedProduct} setSelectedProduct={setSelectedProduct}/>
                    <table className="table fs-14">
                        <TableHeader />
                        <tbody id="tbody">
                            <Item requests={filterItems(requests, filter, selectedProduct)} />
                        </tbody>
                    </table>    

                </div>
            </div>
        </div> 
        
    );
}
 
export default Table;